import { render, staticRenderFns } from "./prebuild-stars.vue?vue&type=template&id=4975a00e&scoped=true&"
import script from "./prebuild-stars.vue?vue&type=script&lang=js&"
export * from "./prebuild-stars.vue?vue&type=script&lang=js&"
import style0 from "./prebuild-stars.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./prebuild-stars.vue?vue&type=style&index=1&id=4975a00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975a00e",
  null
  
)

export default component.exports